<template>
<div>
  <div class="columns is-centered has-background-dvodark">
    <div class="column is-10">
        <div class="b-form-1">
          <h2 class="has-text-white has-text-left is-size-1">Sign Up</h2>
            <div class="field">
                <div class="control">
                  <input id="usernameInput" class="input has-text-white" placeholder="Email" type="text" v-model="username">
                </div>
            </div>
            <div class="field">
              <div class="control">
                <input id="emailInput" class="input has-text-white"  placeholder="Confirm Email" type="email" v-model="email">
              </div>
            </div>
            <div class="field">
              <div class="control">
                <input id="nameInput" class="input has-text-white" placeholder="First Name" type="text" v-model="firstName">
              </div>
            </div>
            <div class="field">
              <div class="control">
                <input id="nameInput" class="input has-text-white" placeholder="Last Name" type="text" v-model="lastName">
              </div>
            </div>
              <div class="field">
              <div class="control">
                <input id="passwordInput" class="input has-text-white"  placeholder="Password" type="password" v-model="pass">
              </div>
            </div>
        </div>
    </div>
  </div>
    <div class="columns is-centered">
    <div class="column is-5">
      <b-button @click="signUp" class="button is-dvogreen" expanded>Sign Up</b-button>
    </div>
  </div>
  <div class="columns has-background-dvodark">
      <div class="column">
        <v-alert />
      </div>
    </div>
</div>
</template>

<script>
import Vue from "vue";
import router from "@/router";
import { mapGetters } from "vuex";
import Alert from "@/components/auth/Alert.vue";
import Amplify from "@aws-amplify/core";
const Logger = Amplify.Logger;
Vue.component("v-alert", Alert);
const logger = new Logger("SignUpPage");
export default {
  data() {
    return {
      username: "",
      email: "", 
      firstName: "",
      lastName: "",
      pass: ""
    };
  },
  mounted() {
    this.$store.dispatch("auth/clearAuthenticationStatus");
  },
  computed: {
    ...mapGetters("auth", ["hasAuthenticationStatus"])
  },
  methods: {
    async signUp() {
      logger.debug("sign-up");
      await this.$store.dispatch("auth/signUp", {
        username: this.username,
        password: this.pass,
        attributes: {
          given_name: this.firstName,
          family_name: this.lastName,
          email: this.email
        }
      });

      if (!this.hasAuthenticationStatus) {
        router.push("confirmSignUp");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h2{
  font-family: "Anton", sans-serif;
}
</style>